import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const FirstCourses = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/' name='Першi страви'/>
            <main className={s.main}>
                <Product name='Бульйон курячий' price='60 грн.' weight='300г.'/>
                <Product name='Борщ червоний фірмовий' price='80 грн.' weight='350г.'/>
                <Product name='Уха з лососем' price='100 грн.' weight='350г.'/>
                <Product name='пампушки з поливкою' price='25 грн.'/>
            </main>
        </div>
    )
}

export default FirstCourses;